(function(facebook, $, undefined)
{
	var isLoaded;

	facebook.init = function()
	{
		this.isLoaded = false;

		facebook.checkLoaded();
		facebook.uiEvents();
	};

	facebook.checkLoaded = function()
	{
		// check if fb js was loaded before initializing our scripts (unlikely)
		if (typeof (FB) != 'undefined' && window.fbAsyncInit.hasRun)
		{
			facebook.isLoaded = true;
		}

		// listen for fb being loaded
		else
		{
			// fb js has successfully loaded and connected to our app
			$(document).on('facebookInitiated', function()
			{
				facebook.isLoaded = true;
			});
		}

		// if we need to run functions after fb is loaded
		//$(document).trigger('facebookLoaded');
	};

	facebook.uiEvents = function()
	{
		$('.facebook-connect-btn').on('click', clickFacebookConnectButton);


		function clickFacebookConnectButton(e)
		{
			e.preventDefault();

			facebook.checkLoginStatus();
		}
	};

	facebook.checkLoginStatus = function()
	{
		if (!facebook.isLoaded)
			return false;

		FB.login(function(response)
		{
			if (!response.authResponse)
				return false;

			// logged into facebook and your app
			if (response.status === 'connected')
			{
				facebook.checkNmConnection();
			}

		}, {
			scope: 'email,public_profile',
			return_scopes: true
		});
	};

	facebook.checkNmConnection = function()
	{
		main.showLoader('spin');

		$.ajaxHandler({
			url: '/ajax/connectWithFacebook',
			type: 'POST',
			dataType: 'json',
			cache: false
		}).done(function(data)
		{
			main.hideLoader();

			main.showMessageBox(data['text'], 'html');

			setTimeout(function() {
				location.href = '/';
			}, 4000);
		});
	};

}(window.facebook = window.facebook || {}, jQuery));

$(function()
{
	facebook.init();
});

// listen on successful fb js load
window.fbAsyncInit = function()
{
	FB.init({
		appId      : jsData['Facebook']['AppId'],
		cookie     : true,  // enable cookies to allow the server to access the session
		//xfbml      : true,  // parse social plugins on this page
		version    : 'v2.12' // use graph api
	});

	$(document).trigger('facebookInitiated');
};

// load the sdk async
(function(d, s, id) {
	var js, fjs = d.getElementsByTagName(s)[0];
	if (d.getElementById(id)) return;
	js = d.createElement(s); js.id = id;
	js.src = "//connect.facebook.net/en_US/sdk.js";
	fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));
